module.exports = __webpack_public_path__ + "img/KC.910795d9.jpg";